const appconfig = {
  responsetype: "token",
  token: "accesstoken",
  fullname: "fullname",
  scope: "openid profile",
  redirecturi: window.location.origin,
  clientid: "",
  domain: "",
  audience: "",
  apiendpoint: "",
  loginurl: ""
};

switch (window.location.host) {
  case "apps.local:8081":
  case "apps.bttest.net":
    appconfig.clientid = "KiODRCPqd0HbZkTVfHBmQWaEO2sAGEN4";
    appconfig.domain = "auth.bttest.net";
    appconfig.audience = "https://api.bttest.net";
    appconfig.loginurl = "https://login.bttest.net";

    break;
  case "apps.btstage.net":
    appconfig.clientid = "YplNDreava92QMpbOuiIsaFoIKZXInK6";
    appconfig.domain = "auth.btstage.net";
    appconfig.audience = "https://api.btstage.net";
    appconfig.loginurl = "https://login.btstage.net";

    break;
  case "apps.btharald.net":
    appconfig.clientid = "LJz578h7Ax6t2hEeWQSwDSPJDsu1K4FJ";
    appconfig.domain = "auth.btharald.net";
    appconfig.audience = "https://api.btharald.net";
    appconfig.loginurl = "https://login.btharald.net";

    break;
  case "apps.bluetooth.com":
    appconfig.clientid = "bSQpM2aVCjkHRjfz9vWn6XN8cV7lHsl0";
    appconfig.domain = "authaz.bluetooth.com";
    appconfig.audience = "https://api.bluetooth.com";
    appconfig.loginurl = "https://login.bluetooth.com";
    break;
  default:
    break;
}

export default appconfig;
